<template>
    <b-card v-if="certLoading" class="mt-3" border-variant="primary" >
        <b-spinner type="grow" variant="primary" label="Загрузка..." />
    </b-card>
    <b-card v-else border-variant="success" header-bg-variant="success" header-text-variant="light" :header="cert.label">
        <b-card-text v-for="(item, i) in certInfo" :key="i" class="mb-2">
            {{ item.title }}:
            <strong>{{ item.value }}</strong>
        </b-card-text>
    </b-card>
</template>

<script>
import { getAlgorithmName, getCertStatus, getProviderName, parseCertNames } from './utils'
import format from 'date-fns/format'

export default {
    name: "EcpCertCard",
    props: {
        cert: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            certInfo: [],
            certLoading: true,
        }
    },
    watch: {
        cert(cert) {
            this.loadCertInfo(cert);
        },
    },
    mounted() {
        this.loadCertInfo(this.cert)
    },
    methods: {
        async loadCertInfo(cert) {
            this.certLoading = true;

            const algorithm = await getAlgorithmName(cert._cadesCertificate);
            const provider = await getProviderName(cert._cadesCertificate);
            const status = await getCertStatus(cert);
            const subjectNames = this.cert.subjectName ? parseCertNames(this.cert.subjectName) : {};
            const issuerNames = this.cert.issuerName ? parseCertNames(this.cert.issuerName) : {};

            this.certInfo = [
                { title: "Владелец", value: subjectNames["CN"] },
                { title: "Издатель", value: issuerNames["CN"] },
                { title: "Выдан", value: format(new Date(cert.validFrom), 'dd.MM.yyyy HH:mm') },
                { title: "Действителен до", value: format(new Date(cert.validTo), 'dd.MM.yyyy HH:mm') },
                { title: "Алгоритм ключа", value: algorithm },
                { title: "Криптопровайдер", value: provider },
                { title: "Статус", value: status },
            ];

            this.certLoading = false;
        },
    },
};
</script>
